import { jobStates } from '@/constants/manageJobsStatus';

export function getSlugByJobStatus(status) {
  const jobStatesArray = Object.values(jobStates).map((item) => item);

  const selectedJobByStatus = jobStatesArray.find(
    (item) => item.value === status
  );

  return selectedJobByStatus?.slug;
}
